<template>
  <div class="container cartContainer">
    <div class="isLoading" v-if="isLoading">
      <div class="spinner">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h5 class="pageTitle">Panier</h5>

    <cart-container />
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import CartContainer from '../../components/Panier/Panier_Container';

  export default {
    components: { CartContainer },
    data() {
      return {
        isLoading: false
      };
    },
    computed: {
      ...mapState({
        items: state => state.cart.all.items,
        connected: state => state.account.status.loggedIn,
        userInfos: state => state.account.user.infos
      })
    },
    mounted() {}
  };
</script>

<style scoped>
.cartContainer {
  position: relative;
  margin-top: 15px;
}

.cartContainer .isLoading {
  position: absolute;
  background-color: rgba(100, 100, 100, 0.05);
  width: 100%;
  height: 100%;
  z-index: 800;
}

.cartContainer .isLoading .spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.table td {
  vertical-align: baseline;
}

.table h4 {
  font-size: 15px;
}
</style>
